import React from 'react'
import logo from '../img/Logo transparent clean.png'
import { Link } from 'react-router-dom'
import Socials from './Socials'


export default function Footer() {
  return (
    <div className="footer blue-bg yellowtext divider-top">
      <div className="container">
        <div className="row">
          <div className='col m4 s12'>
            <a href="#!" className="brand-logo"><img src={logo} alt='D1sabl3d logo' width={65}/></a> 
          </div>
          <div className='col m4 s12 center valign-wrapper'>
            <p className='footer-text'>Made with <i className='material-icons tiny'>favorite</i> by D1sabl3d, powered by Fourthwall</p>
          </div>
          <div className='col m4 s12'>
            <h6>Some handy links</h6>
            <ul className='footer-links'>
              <li><Link className='yellowtext' to='/tos'>Terms of Service</Link></li>
              <li><Link className='yellowtext' to='/privacy'>Privacy Policy</Link></li>
              
            </ul>
            <Socials/>
          </div>
        </div>
      </div>
    </div>
  )
}
